var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcase({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.12816 4.82051C7.12816 3.26279 8.39095 2 9.94868 2H14.0512C15.609 2 16.8718 3.26279 16.8718 4.82051V6.10256H19.1794C20.7372 6.10256 22 7.36535 22 8.92308V14.2952C22.0002 14.3071 22.0002 14.319 22 14.3308V19.1795C22 20.7372 20.7372 22 19.1794 22H4.82047C3.26275 22 1.99996 20.7372 1.99996 19.1795V14.3306C1.99969 14.3189 1.99969 14.3071 1.99996 14.2954V8.92308C1.99996 7.36535 3.26275 6.10256 4.82047 6.10256H7.12816V4.82051ZM4.82047 7.64103C4.11241 7.64103 3.53842 8.21502 3.53842 8.92308V13.7887C6.16716 14.7867 9.01888 15.3333 12 15.3333C14.981 15.3333 17.8328 14.7867 20.4615 13.7887V8.92308C20.4615 8.21502 19.8875 7.64103 19.1794 7.64103H4.82047ZM15.3333 6.10256H8.66663V4.82051C8.66663 4.11246 9.24062 3.53846 9.94868 3.53846H14.0512C14.7593 3.53846 15.3333 4.11246 15.3333 4.82051V6.10256ZM20.4615 15.4271C17.814 16.3629 14.9657 16.8718 12 16.8718C9.03422 16.8718 6.18587 16.3629 3.53842 15.4271V19.1795C3.53842 19.8875 4.11241 20.4615 4.82047 20.4615H19.1794C19.8875 20.4615 20.4615 19.8875 20.4615 19.1795V15.4271ZM11.2307 13.0256C11.2307 12.6008 11.5751 12.2564 12 12.2564H12.0102C12.435 12.2564 12.7794 12.6008 12.7794 13.0256C12.7794 13.4505 12.435 13.7949 12.0102 13.7949H12C11.5751 13.7949 11.2307 13.4505 11.2307 13.0256Z",
    fill: "#D53E20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.591a359f101b68b53a91352528fac400.svg";
export { ForwardRef as ReactComponent };